"use client";

import React, { useEffect, useRef } from 'react';

const SplashScreen: React.FC = () => {
  const removedRef = useRef(false);

  useEffect(() => {
    const rgbToHex = (color: string): string | null => {
      const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
      if (!match) return null;

      const toHex = (value: string) => Number.parseInt(value, 10).toString(16).padStart(2, '0');
      return `#${toHex(match[1])}${toHex(match[2])}${toHex(match[3])}`;
    };

    const syncChromeWithBackground = () => {
      const bodyBg = window.getComputedStyle(document.body).backgroundColor;
      const htmlBg = window.getComputedStyle(document.documentElement).backgroundColor;
      const resolvedBg = bodyBg || htmlBg;

      if (!resolvedBg) return;

      const hex = rgbToHex(resolvedBg);
      if (!hex) return;

      const themeMeta = document.querySelector('meta[name="theme-color"]');
      if (themeMeta) {
        themeMeta.setAttribute('content', hex);
      }
    };

    const removeSplash = () => {
      if (removedRef.current) return;
      removedRef.current = true;

      syncChromeWithBackground();

      const splash = document.getElementById('splash-screen');
      if (splash) {
        splash.classList.add('splash-fade-out');
        window.setTimeout(() => {
          if (splash.parentNode) {
            splash.remove();
          }
        }, 360);
      }
    };

    const timer = window.setTimeout(removeSplash, 1200);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return null;
};

export default SplashScreen;
